'use strict';

var axios = require('axios');
var consts = require('../consts.js');
var NetworkError = require('../errors/network/NetworkError.js');
var BadRequestError = require('../errors/network/BadRequestError.js');
var UnauthorizedError = require('../errors/network/UnauthorizedError.js');
var LockedError = require('../errors/network/LockedError.js');
var TooManyRequestsError = require('../errors/network/TooManyRequestsError.js');
var consts$1 = require('./consts.js');

class AuthApiClient {
    _params;
    _instance;
    constructor(params) {
        const { prefix = consts$1.AUTH_ROUTER_PREFIX_DEFAULT, webPath } = params || {};
        this._params = {
            prefix,
            webPath,
        };
        this._instance = axios.create({
            timeout: 5000,
            responseType: 'json',
            withCredentials: true,
            baseURL: this._params.webPath,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        this._instance.interceptors.response.use((_) => _, (error) => {
            if (axios.isAxiosError(error)) {
                if (!error.response) {
                    return Promise.reject(this._createError(error?.status || 500, { message: error.message }));
                }
                const { status, data } = error.response;
                const { message, error: errorFromServer } = data;
                const retryAfter = error.response.headers?.[consts.HEADERS.RETRY_AFTER] ||
                    error.response.headers?.[consts.HEADERS.RETRY_AFTER.toLowerCase()];
                if (status === 400 && errorFromServer) {
                    return Promise.reject(new BadRequestError.BadRequestError({
                        code: errorFromServer.code,
                        target: errorFromServer.target,
                        message: errorFromServer.message,
                        details: errorFromServer.details,
                    }));
                }
                return Promise.reject(this._createError(status, { message: message || errorFromServer?.message, meta: { retryAfter } }));
            }
            return Promise.reject(error);
        });
    }
    _createError(status, params) {
        const { message, meta } = params || {};
        const { retryAfter } = meta || {};
        switch (status) {
            case 400:
                return new BadRequestError.BadRequestError({ message });
            case 401:
                return new UnauthorizedError.UnauthorizedError();
            case 423:
                return new LockedError.LockedError(message);
            case 429:
                return new TooManyRequestsError.TooManyRequestsError(message, retryAfter);
            default:
                return new NetworkError.NetworkError(message);
        }
    }
    async sendOTPByPhoneNumber(params) {
        const { phone, returnUrl, name, email, authCodeChannel, source, customer, productName, productId } = params;
        const { prefix } = this._params;
        const url = new URL(`${prefix}${consts$1.ROUTES.SILENT_SIGNIN}`, 'http://mock.tv');
        await this._instance.post(url.pathname, {
            phone,
            returnUrl,
            name,
            email,
            authCodeChannel,
            source,
            customer,
            productName,
            productId,
        });
    }
    async getConsents(params) {
        const { prefix } = this._params;
        const { phone, code, productId } = params;
        const url = new URL(`${prefix}${consts$1.ROUTES.SILENT_SIGNIN_VERIFY_AND_CONSENTS}`, 'http://mock.tv');
        const { data } = await this._instance.post(url.pathname, {
            phone,
            code,
            productId,
        });
        const { token, agreements } = data;
        return { token, agreements };
    }
    async verifyPhoneNumberByReferenceToken(params) {
        const { prefix } = this._params;
        const { referenceToken, agreements } = params;
        const url = new URL(`${prefix}${consts$1.ROUTES.SILENT_SIGNIN_CONSENTS}`, 'http://mock.tv');
        const { data } = await this._instance.post(url.pathname, {
            referenceToken,
            agreements,
        });
        const { otac, username } = data;
        return { otac, username };
    }
    async getConnectTokenSet(params) {
        const { prefix } = this._params;
        const { otac, username } = params;
        const url = new URL(`${prefix}${consts$1.ROUTES.SILENT_CONNECT_TOKEN}`, 'http://mock.tv');
        const { data } = await this._instance.post(url.pathname, { otac, username });
        return data;
    }
    /** @deprecated */
    async verifyPhoneNumberByOTP(params) {
        const { phone, code, productId, agreements } = params;
        const { prefix } = this._params;
        const url = new URL(`${prefix}${consts$1.ROUTES.SILENT_SIGNIN_VERIFY}`, 'http://mock.tv');
        const { data } = await this._instance.post(url.pathname, {
            phone,
            code,
            productId,
            agreements,
        });
        const { otac, username } = data;
        return { otac, username };
    }
}

exports.AuthApiClient = AuthApiClient;
//# sourceMappingURL=authApiClient.js.map
